import React from "react";

import LogoPath from "@images/logo_full.svg";

import Image from "@/components/common/image";

import "./styles.scss";

const LandingHeader = () =>
  (
    <header className="landing-header">
      <Image src={LogoPath} className="landing-header__logo" alt="Lunaro" priority />
      <p>Подсветим ваш путь</p>
    </header>
  );

export default LandingHeader;
